<template>
  <div id="app-layout-card" class="app-layout app-layout-card" :style="dashboardWrapperStyles">
    <div class="app-layout-card-wrpper">
      <div class="container">
        <div class="app-layout-card-container">
          <div class="app-layout-card-content">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutCard',

  data() {
    return {
      viewHeight: 0,
    };
  },

  computed: {
    dashboardWrapperStyles() {
      return {
        minHeight: `${this.viewHeight}px`,
      };
    },
  },

  methods: {
    onWindowResize() {
      if (window.innerWidth >= 576) {
        this.viewHeight = window.innerHeight - 71;
      } else {
        this.viewHeight = window.innerHeight - window.innerWidth * 0.6;
      }
    },
  },

  mounted() {
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
};
</script>
